import { render, staticRenderFns } from "./ListenFreeTag.vue?vue&type=template&id=97a031aa&scoped=true&"
import script from "./ListenFreeTag.vue?vue&type=script&lang=js&"
export * from "./ListenFreeTag.vue?vue&type=script&lang=js&"
import style0 from "./ListenFreeTag.vue?vue&type=style&index=0&id=97a031aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a031aa",
  null
  
)

export default component.exports